module.exports = __webpack_public_path__ + "static/img/icon_zfgk.b685c38d.png";